import { useState } from "react";
import { toast } from "sonner";
import { Field, TextInput } from "@/tools/ui";

const hexToRgb = (hex) => {
  const m = hex.replace("#", "").match(/^([0-9a-f]{6})$/i);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
};

const rgbToHsl = (r, g, b) => {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
};

const Swatch = ({ label, value, testid }) => (
  <div className="border border-border bg-muted p-4">
    <p className="overline text-muted-foreground">{label}</p>
    <p data-testid={testid} className="mt-1 font-mono-tech text-lg font-bold break-all">{value}</p>
  </div>
);

export const ColorConverter = () => {
  const [hex, setHex] = useState("#002FA7");
  const rgb = hexToRgb(hex);
  const hsl = rgb ? rgbToHsl(rgb.r, rgb.g, rgb.b) : null;

  return (
    <div className="space-y-6">
      <div className="flex items-end gap-4">
        <Field label="Pick a color"><input data-testid="color-picker" type="color" value={/^#[0-9a-f]{6}$/i.test(hex) ? hex : "#000000"} onChange={(e) => setHex(e.target.value)} className="h-11 w-16 cursor-pointer border border-border bg-card" /></Field>
        <div className="flex-1"><Field label="HEX"><TextInput data-testid="color-hex-input" value={hex} onChange={(e) => setHex(e.target.value)} className="font-mono-tech" /></Field></div>
      </div>
      <div className="h-24 w-full border border-border" style={{ backgroundColor: /^#[0-9a-f]{6}$/i.test(hex) ? hex : "#fff" }} data-testid="color-preview" />
      {rgb && hsl && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <Swatch label="HEX" value={hex.toUpperCase()} testid="color-hex" />
          <Swatch label="RGB" value={`rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`} testid="color-rgb" />
          <Swatch label="HSL" value={`hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%)`} testid="color-hsl" />
        </div>
      )}
    </div>
  );
};
